module.exports = __webpack_public_path__ + "static/media/icon_schedule_message_gray.46929223.svg";